import { StateCreator } from "zustand";

import { RootStore } from ".";

export interface GeolocationActions {
	openGeolocationTool: () => void;
}

export type GeolocationStore = GeolocationActions;

export const createGeolocationSlice: StateCreator<
	RootStore,
	[],
	[],
	GeolocationStore
> = (set) => ({
	openGeolocationTool: () => set({ currentMapToolView: "geolocation" }),
});
